// extracted by mini-css-extract-plugin
export default {"PageContainer":"DefaultRouter_PageContainer__jChi9","RightColumnContainer":"DefaultRouter_RightColumnContainer__Rj-hX","ContentContainer":"DefaultRouter_ContentContainer__F1oIA"};